import TextSearchAdapterType from '@jbrowse/core/pluggableElementTypes/TextSearchAdapterType';
import Plugin from '@jbrowse/core/Plugin';
import { AdapterClass as TrixTextSearchAdapterClass, configSchema as trixAdapterConfigSchema, } from './TrixTextSearchAdapter';
export default class TrixPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.name = 'TrixPlugin';
    }
    install(pluginManager) {
        pluginManager.addTextSearchAdapterType(() => new TextSearchAdapterType({
            name: 'TrixTextSearchAdapter',
            displayName: 'Trix text search adapter',
            configSchema: trixAdapterConfigSchema,
            AdapterClass: TrixTextSearchAdapterClass,
            description: 'Trix adapter',
        }));
    }
}
